<head>
  <link rel="stylesheet" type="text/css" href="http://jsxgraph.uni-bayreuth.de/distrib/jsxgraph.css" />
</head>
<script lang="ts">
  import JXG from 'jsxgraph/distrib/jsxgraphcore.js';
  import { onMount } from 'svelte';
  import uqnSplit from './functions/uqnSplit';
  import Fraction from './functions/fractionClass';
  export let uqn:number;
  var brd;
  let initialized = false, brdDummy = "";
  $: brdDummy = updateBoard(uqn);

	onMount(() => {
    initialized = true;
    updateBoard(uqn);
  });

  function updateBoard(u:number):string{
    const [t,a,b,c] = uqnSplit(u);
    if (initialized){    
      switch (t){
        case 1:
          // xMin, yMax, xMax, yMin
          brd = JXG.JSXGraph.initBoard('jxgbox',{axis:true,boundingbox: [-0.1, 1.1*a/b, 2, -0.1*a/b]});
          brd.suspendUpdate();
          var curve = brd.create('curve',
            [ function(t){return t},
              function(t){return a/b - a*(10-c)/10/b * Math.exp(-b*t);},
              0, 
              2],
            {strokeColor:'#aa2233',strokeWidth:3});
          break;
        case 2:
          // xMin, yMax, xMax, yMin
          brd = JXG.JSXGraph.initBoard('jxgbox',{axis:true,boundingbox: [-0.1, 1.1*(10+c)/10*a/b, 2, -0.1*a/b]});
          brd.suspendUpdate();
          var curve = brd.create('curve',
            [ function(t){return t},
              function(t){return a/b - a*(-c)/10/b * Math.exp(-b*t);},
              0, 
              2],
            {strokeColor:'#aa2233',strokeWidth:3});
          break;
        case 3:
          // xMin, yMax, xMax, yMin
          const bQn = new Fraction(b,10).simplify();
          const AFrac = new Fraction(a*(c-10),10).divide(bQn);
          const tAns = (Math.log(-10/(c-10))/(bQn.eval()));
          brd = JXG.JSXGraph.initBoard('jxgbox',{axis:true,boundingbox: [-0.1*tAns, 1.1*(c*a/b), 1.1*tAns, -0.1*c*a/b]});
          brd.suspendUpdate();
          console.log(AFrac.eval());
          var curve = brd.create('curve',
            [ function(t){return t},
              function(t){return 10*a/b + AFrac.eval() * Math.exp(b*t/10);},
              0, 
              tAns],
            {strokeColor:'#aa2233',strokeWidth:3});
          break;
        case 4:
          // xMin, yMax, xMax, yMin
          const k = 3;
          const tMax = Math.log( 10 * ( k * (10+c) / 10 - 1 ) / c )/ b;
          const y0 = (10+c)/10*a/b;
          brd = JXG.JSXGraph.initBoard('jxgbox',{axis:true,boundingbox: [-0.1*tMax, 1.1*k*y0, tMax, -0.2*y0]});
          brd.suspendUpdate();
          var curve = brd.create('curve',
            [ function(t){return t},
              function(t){return a/b + a*(c)/10/b * Math.exp(b*t);},
              0, 
              tMax],
            {strokeColor:'#aa2233',strokeWidth:3});
          break;
      }
      brd.create('grid',[]);
      brd.unsuspendUpdate();
    }
    return "";
  }
</script>
<div id="jxgbox" style="width:90%; height:300px;">{brd}</div>